export const USER_LOGIN = "userLogin/loginSuccess";
export const USER_LOGOUT = "userLogout/logoutSuccess";
export const  IS_LOADING = "userisloading/loading"
export const USER_LOGIN_ERROR = "userLogin/Error";
export const USER_LODING_FALSE = "USER_LODING_FALSE";